type TrackingScopeConfig = {
  value?: string;
  required: boolean;
  default: string;
};

type TrackingScopeValues = {
  [key: string]: string;
};

type TrackingScopeDefs = {
  [key: string]: string;
};

const DEFAULT_CONFIG = {
  required: false,
  default: '',
};

export class TrackingScopeApi {
  _trackingScopeParams: Map<string, TrackingScopeConfig>;

  constructor() {
    this._trackingScopeParams = new Map();
  }
  add(key: string, config: Partial<TrackingScopeConfig>) {
    this._trackingScopeParams.set(key, { ...DEFAULT_CONFIG, ...config });
    return this;
  }
  get(keys: string | string[] | undefined): TrackingScopeValues {
    if (!keys) {
      keys = Array.from(this._trackingScopeParams.keys());
    }

    if (!Array.isArray(keys)) {
      keys = [keys];
    }

    return keys.reduce((prev, cur) => {
      const config = this._trackingScopeParams.get(cur);
      const value = config ? config.value || config.default : undefined;
      if (!value && config && config.required) {
        throw new Error(`Tracking Scope param \`${cur}\` is required.`);
      }
      return { ...prev, [cur]: value };
    }, {});
  }
  set(definitions: TrackingScopeDefs) {
    for (const [key, value] of Object.entries(definitions)) {
      if (typeof value !== 'string') {
        throw new Error(`Tracking scope param \`${key}\` must be a string.`);
      }

      const config = this._trackingScopeParams.get(key);

      // If the params hasn't been added or the value is falsy when required
      // bail out of setting it.
      if (!config) continue;

      if (config.required && !config.default && !value) {
        throw new Error(`Tracking scope param \`${key}\` is required.`);
      }

      this._trackingScopeParams.set(key, { ...config, value });
    }
    return this;
  }
}

// Setup our global scope values
export const trackingScopeApi = new TrackingScopeApi();

trackingScopeApi.add('service', { required: true }).add('release', {
  required: true,
  default: '<unknown>',
});

export const configureTracking = (definitions: TrackingScopeDefs) => {
  trackingScopeApi.set(definitions);
};

export const getTrackingScope = (
  keys: string | string[]
): TrackingScopeValues => trackingScopeApi.get(keys);
